import { sumProduct } from "../functions";
import type { AnnualConst, CalcOptions } from "../algorithm.types";

type CalculateAnnualDemandParams = {
  calcOptions: Pick<CalcOptions, "dayYearPercent">;
  annualConst: Pick<AnnualConst, "averageDemandPerDay">;
};

const calculateAnnualDemand = ({
  calcOptions,
  annualConst,
}: CalculateAnnualDemandParams): number =>
  (sumProduct(annualConst.averageDemandPerDay, calcOptions.dayYearPercent) *
    365 *
    24) /
  1000;

export default calculateAnnualDemand;
